// this file is automatically generated by git.version.ts script
export const versions = {date: 1701898010308, version: '4.5.0.8fff25e', revision: '8fff25ee640feb8c3f3425aa27556557bb0a963b', branch: 'release-5.23'};